<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :span="4">
            <el-button size="medium" type="success" @click="openDialog(true, null)"
              v-if="checkButtonPermission('system:manage:menu:add')">新增菜单</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-tree :data="menuTreeData" node-key="menuId" default-expand-all :expand-on-click-node="false"
          :props="defaultProps">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <el-button type="text" size="mini" @click="() => addSubMenu(data)"
                v-if="data.type === 1 && checkButtonPermission('system:manage:menu:addChild')">
                添加子菜单
              </el-button>
              <el-button type="text" size="mini" @click="() => openDialog(false, data)"
                v-if="checkButtonPermission('system:manage:menu:edit')">
                编辑
              </el-button>
              <el-button type="text" size="mini" @click="() => deleteMenu(data.menuId)"
                v-if="checkButtonPermission('system:manage:menu:delete')">
                删除
              </el-button>
            </span>
          </span>
        </el-tree>
      </div>
    </el-card>
    <el-dialog :title="menudialogTitle + '菜单'" :visible.sync="dialogVisible" :modal="false"
      :close-on-click-modal="false" @close="resetForm()">
      <el-form :model="menuForm" label-width="120px" size="medium" style="padding: 0 10%;">
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="menuForm.type">
            <el-radio :label="1">菜单</el-radio>
            <el-radio :label="2">按钮</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="menuForm.name" clearable></el-input>
        </el-form-item>
        <!--        <el-form-item label="菜单URL" prop="url">-->
        <!--          <el-input v-model="menuForm.url" clearable></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item label="授权标识" prop="perms">
          <el-input v-model="menuForm.perms" clearable></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="orderNum">
          <el-input-number v-model="menuForm.orderNum" controls-position="right"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('menuForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
export default {
  name: "menuList",
  data() {
    return {
      key: '',
      menuTreeData: [],
      defaultProps: {
        children: 'childrenList',
        label: 'name'
      },
      menuForm: { type: 1, orderNum: 0 },
      addFlag: true,
      dialogVisible: false,
      dialogOperation: '',
      menudialogTitle: '编辑'
    }
  },
  created() {
    this.getAllMenus();
  },
  mounted() {
  },
  methods: {
    getAllMenus() {
      this.$http.post('/api/system/sysMenu/queryMenuList', {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        console.log(resp.data)
        let data = resp.data;
        this.menuTreeData = data.data;
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      });
    },
    editMenu(row) {
      this.$http.post('/api/system/sysMenu/update', this.menuForm, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        if (data.code === "0") {
          this.$message({
            message: '编辑菜单信息成功',
            type: 'success'
          });
          this.dialogVisible = false;
          this.resetForm();
          this.getAllMenus();
        } else {
          this.$alert(data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    deleteMenu(menuId) {
      this.$confirm('此操作将永久该菜单信息, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/api/system/sysMenu/delete?sysMenuId=' + menuId, {}, {
          headers: {
            accessToken: sessionStorage.getItem('accessToken')
          }
        }).then(resp => {
          let data = resp.data;
          if (data.code === "0") {
            this.$message({
              message: '删除菜单信息成功',
              type: 'success'
            });
            this.dialogVisible = false;
            this.getAllMenus();
          } else {
            this.$alert('' + data.message, '温馨提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(e => {
          this.$alert('' + e, '温馨提示', {
            confirmButtonText: '确定'
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addMenu() {
      let reqParam = {
        name: this.menuForm.name,
        // url: this.menuForm.url,
        perms: this.menuForm.perms,
        orderNum: this.menuForm.orderNum,
        parentId: this.menuForm.parentId,
        type: this.menuForm.type
      };
      this.$http.post('/api/system/sysMenu/save', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        console.log(resp);
        let data = resp.data;
        if (data.code === "0") {
          this.$message({
            message: '新增菜单信息成功',
            type: 'success'
          });
          this.dialogVisible = false;
          this.resetForm();
          this.getAllMenus();
        } else {
          this.$alert(data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })

    },
    submitForm(formName) {
      if ('add' == this.dialogOperation) {
        this.addMenu();
      } else if ('edit' == this.dialogOperation) {
        console.log('edit');
        this.editMenu(formName);
      } else {
        console.log('error submit!!');
        return false;
      }
    },
    openDialog(addFlag, row) {
      if (addFlag) {
        this.menudialogTitle = '新增';
        this.dialogOperation = 'add';
      } else {
        this.menudialogTitle = '编辑';
        let temp = {};
        Object.assign(temp, row);
        console.log(temp);
        this.menuForm = temp;
        this.dialogOperation = 'edit';
      }
      this.dialogVisible = true;
    },
    addSubMenu(row) {
      let temp = {};
      Object.assign(temp, row);
      console.log(temp);
      this.menuForm.parentId = temp.menuId;
      this.openDialog(true, null);
    },
    resetForm() {
      this.menuForm = { type: 1, orderNum: 0 };
    },
    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    }
  }
}
</script>

<style scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/menuList.vue